import React from 'react';

import { NumberFormat } from '@instinet-analytics/core-lib';
import { SymbolInfoDataMessage } from './SymbolInfoDataMessage';
import DetailsPanelValue from 'utils/components/DetailsPanel/DetailsPanelValue';
import { ResponsiveColumns } from 'utils/components/ResponsiveColumns/ResponsiveColumns';

export default function SymbolInfoData(props: {
    numberFormat: NumberFormat;
    width: number;
    data?: SymbolInfoDataMessage;
}) {
    const { numberFormat, width, data } = props;
    if (!data) {
        return null;
    }

    return (
        <ResponsiveColumns
            className={'symbol-info-data'}
            width={width}
            breaks={[400]}
        >
            <ResponsiveColumns.Row className="pnc-section">
                <ResponsiveColumns.Column />
                <ResponsiveColumns.Column>
                    <DetailsPanelValue
                        label="PNC"
                        value={numberFormat.n2(data.pncLocal)}
                    />
                </ResponsiveColumns.Column>
            </ResponsiveColumns.Row>

            <ResponsiveColumns.Row className="main-section">
                <ResponsiveColumns.Column>
                    <div className="field value">{data.ind}</div>
                    <div className="field value">{data.sect}</div>
                    <div className="field value">{data.subSector}</div>
                </ResponsiveColumns.Column>
                <ResponsiveColumns.Column>
                    <DetailsPanelValue label="Country" value={data.country} />
                    <DetailsPanelValue label="Currency" value={data.currency} />
                    <div className="field value">{data.primaryExch}</div>
                </ResponsiveColumns.Column>
            </ResponsiveColumns.Row>

            <ResponsiveColumns.Row className="secondary-section">
                <ResponsiveColumns.Column>
                    <DetailsPanelValue
                        label="ADV"
                        value={numberFormat.n0(data.adv)}
                    />
                    <DetailsPanelValue
                        label="Avg Daily Trades"
                        value={numberFormat.n0(data.avgDailyTrades)}
                    />
                    <DetailsPanelValue
                        label="Eff Spread (bps)"
                        tooltip="Effective Spread (bps)"
                        value={numberFormat.n2(data.effectiveSpread)}
                    />
                    <DetailsPanelValue
                        label="Dly Volatility (%)"
                        tooltip="Daily Volatility (%)"
                        value={numberFormat.n2(data.dailyVolatilityPct)}
                    />
                    <DetailsPanelValue
                        label="Symbol Index"
                        value={data.symbolIndex}
                    />
                </ResponsiveColumns.Column>
                <ResponsiveColumns.Column>
                    <div className="field value">{data.time}</div>
                    <DetailsPanelValue
                        label="Mdn Quote Size"
                        tooltip="Median Quote Size"
                        value={numberFormat.n0(data.medianQuotes)}
                    />
                    <DetailsPanelValue
                        label="Mdn Trade Size"
                        tooltip="Median Trade Size"
                        value={numberFormat.n0(data.medianTrades)}
                    />
                    <DetailsPanelValue
                        label="Lot Size"
                        value={numberFormat.n0(data.lot)}
                    />
                    <DetailsPanelValue
                        label="Tick Size"
                        value={numberFormat.n2to4(data.tickSize)}
                    />
                </ResponsiveColumns.Column>
            </ResponsiveColumns.Row>
        </ResponsiveColumns>
    );
}
